<div class="page-sidebar" [style.backgroundColor]="util?.configuration?.crisisModeBackgroundColor || null">
  <div class="sidebar-header" [style.backgroundColor]="util?.configuration?.headerColor || null">
    <img alt="logo" class="brand-sidebar " (click)="menu.goToDefaultTool()"
      [src]="util.darkMode ? util?.configuration?.externalLogoImageInvert : util?.configuration?.externalLogoImage">
    <button (click)="menu.toggleSidebar()" class="d-sm-block d-md-block d-lg-none btn btn-link ">
      <app-icon [name]="'icon-menu'"></app-icon>
    </button>
    <div class="ng-sidebar-controls d-flex align-items-center">
      @if (menu.mode == 'push') {
        <a class="btn btn-icon-link d-none d-md-block btn-xs p-t-5 no-padding m-r-10" (click)="toggleMenuFilter()"
          >
          
          <img [src]="showMenuFilter ? 'https://publicfiles.mybeehome.com/icons/tools/icon-chevron-up.svg': 'https://publicfiles.mybeehome.com/icons/tools/icon-chevron-down.svg'" width="14" height="14" alt="{{'Filtrar menu' | translate}}">
        </a>
      }
      <a (click)="menu.pinSideBar()" class="btn btn-icon-link btn-xs d-none d-md-block no-padding">
        
        <img [src]="menu.mode == 'push' ? 'https://publicfiles.mybeehome.com/icons/tools/icon-pin-2.svg': 'https://publicfiles.mybeehome.com/icons/tools/icon-menu-2.svg'" width="23" height="23" alt="{{'Fixar menu' | translate}}">
      </a>

    </div>
  </div>
  <div class="sidebar-menu" [style.backgroundColor]="util.configuration?.crisisModeBackgroundColor || null">
    @if (showMenuFilter && menu.mode == 'push') {
      <div class="search-input-wrapper no-margin full-width">
        <div class="icon-search">
          <app-icon [name]="'icon-search-3'"></app-icon>
          <input class="search-input" placeholder="{{'Encontre no menu...' | translate}}" aria-label="{{'Encontre no menu...' | translate}}" type="text"
            [(ngModel)]="nameFilter">
          @if (nameFilter) {
            <button class="btn btn-link" [@inOutAnimation] (click)="cancelSearch()"><app-icon
            [name]="'icon-close'" [size]="10"></app-icon></button>
          }
        </div>
      </div>
    }
    <div class="skeleton-left-menu heightForSkeleton-left-menu">
      <ng-container>
        <accordion [isAnimated]="true" [closeOthers]="controlMenuBehavior">
          @for (cat of menu?.sidebarItems; track cat.title; let idx = $index) {
            <accordion-group
              [panelClass]="'card-accordion card-overflow  menu-accordion'" [isOpen]="cat.isopen">
              @if ((cat.podTOs | filterMenu: nameFilter)?.length > 0) {
                <ul class="menu-items" accordion-heading
                  >
                  <li class="menu-category" (click)="onCategoryToggle(cat, $event)"
                    [ngStyle]="util?.configuration?.menuColor !== '#ffffff' ? {'background-color': util?.configuration?.menuColor} : {}">
                    <a class="pointer">
                      @if (locale== 'pt-BR') {
                        <span class="category pointer title" [ngStyle]="{'color': util?.configuration?.fontColor !== '#000000' ? util?.configuration?.fontColor : ''}">
                          {{cat.title | translate}}
                        </span>
                      }
                      @if (locale== 'es-ES') {
                        <span class="category pointer title" [ngStyle]="{'color': util?.configuration?.fontColor !== '#000000' ? util?.configuration?.fontColor : ''}">
                          {{cat.esTitle || (cat.title | translate)}}
                        </span>
                      }
                      @if (locale== 'en-US') {
                        <span class="category pointer title" [ngStyle]="{'color': util?.configuration?.fontColor !== '#000000' ? util?.configuration?.fontColor : ''}">
                          {{cat.enTitle || (cat.title | translate)}}
                        </span>
                      }
                      @if (locale== 'pt-PT') {
                        <span class="category pointer title" [ngStyle]="{'color': util?.configuration?.fontColor !== '#000000' ? util?.configuration?.fontColor : ''}">
                          {{cat.ptTitle || (cat.title| translate)}}
                        </span>
                      }
                    </a>
                    @if (!cat.icon) {
                      <div class="icon-thumbnail pointer icon-menu-items-category" >
                        
                        <img [src]="cat.isopen ? 'https://publicfiles.mybeehome.com/icons/tools/icon-chevron-up.svg': 'https://publicfiles.mybeehome.com/icons/tools/icon-chevron-down.svg'" width="12" height="12" alt="{{'Expandir categoria' | translate}}">
                      </div>
                    }
                    @if (cat.icon) {
                      <div class="icon-thumbnail">
                        <img [src]="'https://publicfiles.mybeehome.com/icons/custom-pods/' + cat.icon" width="24" height="24" [alt]="cat.title">
                      </div>
                    }
                  </li>
                </ul>
              }
              <ul class="menu-items ps">
                @for (pod of cat.podTOs | filterMenu: nameFilter; track pod.id) {
                  <li
                    [ngClass]="{'selected' : pod.selected}">
                    @if (pod?.podType !== 'wikiPage' && pod?.podType !== 'internalLink' && pod?.podType !== 'customLink'  && pod?.podType !== 'blogPost' && pod?.podType !== 'urlIntegration') {
                      <a
                        (click)="onClickPod(pod.id, $event)"  [href]="getPodUrl(pod)">
                        
                        @if (locale == 'pt-BR') {
                          <span class="title"
                          >{{pod?.title}}</span>
                        }
                        @if (locale == 'pt-PT') {
                          <span class="title"
                            >{{pod?.ptTitle ?
                          pod?.ptTitle : pod?.title }}</span>
                        }
                        @if (locale == 'es-ES') {
                          <span class="title"
                            >{{pod?.esTitle ?
                          pod?.esTitle : pod?.title }}</span>
                        }
                        @if (locale == 'en-US') {
                          <span class="title"
                            >{{pod?.enTitle ?
                          pod?.enTitle : pod?.title }}</span>
                        }
                      </a>
                    }
                    @if (pod?.podType === 'wikiPage') {
                      <a (click)="onClickPod(pod.id, $event)"
                        [href]="getPodUrl(pod)">
                        <!-- <span class="title">{{pod.title}}</span> -->
                        @if (locale == 'pt-BR') {
                          <span class="title"
                          >{{pod?.title}}</span>
                        }
                        @if (locale == 'pt-PT') {
                          <span class="title"
                            >{{pod?.ptTitle ?
                          pod?.ptTitle : pod?.title }}</span>
                        }
                        @if (locale == 'es-ES') {
                          <span class="title"
                            >{{pod?.esTitle ?
                          pod?.esTitle : pod?.title }}</span>
                        }
                        @if (locale == 'en-US') {
                          <span class="title"
                            >{{pod?.enTitle ?
                          pod?.enTitle : pod?.title }}</span>
                        }
                      </a>
                    }
                    @if (pod?.podType === 'internalLink') {
                      <a (click)="onClickPod(pod.id, $event)"
                        [href]="getPodUrl(pod)">
                        <!-- <span class="title">{{pod.title}}</span> -->
                        @if (locale == 'pt-BR') {
                          <span class="title"
                          >{{pod?.title}}</span>
                        }
                        @if (locale == 'pt-PT') {
                          <span class="title"
                            >{{pod?.ptTitle ?
                          pod?.ptTitle : pod?.title }}</span>
                        }
                        @if (locale == 'es-ES') {
                          <span class="title"
                            >{{pod?.esTitle ?
                          pod?.esTitle : pod?.title }}</span>
                        }
                        @if (locale == 'en-US') {
                          <span class="title"
                            >{{pod?.enTitle ?
                          pod?.enTitle : pod?.title }}</span>
                        }
                      </a>
                    }
                    @if (pod?.podType === 'blogPost') {
                      <a (click)="onClickPod(pod.id, $event)"
                        [href]="getPodUrl(pod)">
                        <!-- <span class="title">{{pod.title}}</span> -->
                        @if (locale == 'pt-BR') {
                          <span class="title"
                          >{{pod?.title}}</span>
                        }
                        @if (locale == 'pt-PT') {
                          <span class="title"
                            >{{pod?.ptTitle ?
                          pod?.ptTitle : pod?.title }}</span>
                        }
                        @if (locale == 'es-ES') {
                          <span class="title"
                            >{{pod?.esTitle ?
                          pod?.esTitle : pod?.title }}</span>
                        }
                        @if (locale == 'en-US') {
                          <span class="title"
                            >{{pod?.enTitle ?
                          pod?.enTitle : pod?.title }}</span>
                        }
                      </a>
                    }
                    @if (pod?.podType === 'customLink' && !pod?.iframeCustomLink) {
                      <a (click)="onClickPod(pod.id, $event)"
                        [href]="getPodUrl(pod)">
                        <!-- <span class="title">{{pod.title}}</span> -->
                        @if (locale == 'pt-BR') {
                          <span class="title"
                          >{{pod?.title}}</span>
                        }
                        @if (locale == 'pt-PT') {
                          <span class="title"
                            >{{pod?.ptTitle ?
                          pod?.ptTitle : pod?.title }}</span>
                        }
                        @if (locale == 'es-ES') {
                          <span class="title"
                            >{{pod?.esTitle ?
                          pod?.esTitle : pod?.title }}</span>
                        }
                        @if (locale == 'en-US') {
                          <span class="title"
                            >{{pod?.enTitle ?
                          pod?.enTitle : pod?.title }}</span>
                        }
                      </a>
                    }
                    @if (pod?.podType === 'customLink' && pod?.iframeCustomLink) {
                      <a (click)="onClickPod(pod.id, $event)"
                        [href]="getPodUrl(pod)">
                        <!-- <span class="title">{{pod.title}}</span> -->
                        @if (locale == 'pt-BR') {
                          <span class="title"
                          >{{pod?.title}}</span>
                        }
                        @if (locale == 'pt-PT') {
                          <span class="title"
                            >{{pod?.ptTitle ?
                          pod?.ptTitle : pod?.title }}</span>
                        }
                        @if (locale == 'es-ES') {
                          <span class="title"
                            >{{pod?.esTitle ?
                          pod?.esTitle : pod?.title }}</span>
                        }
                        @if (locale == 'en-US') {
                          <span class="title"
                            >{{pod?.enTitle ?
                          pod?.enTitle : pod?.title }}</span>
                        }
                      </a>
                    }
                    @if (pod?.podType === 'urlIntegration' && !pod?.iframeCustomLink) {
                      <a (click)="onClickPod(pod.id, $event)"
                        [href]="getPodUrl(pod)">
                        <!-- <span class="title">{{pod.title}}</span>     -->
                        @if (locale == 'pt-BR') {
                          <span class="title"
                          >{{pod?.title}}</span>
                        }
                        @if (locale == 'pt-PT') {
                          <span class="title"
                            >{{pod?.ptTitle ?
                          pod?.ptTitle : pod?.title }}</span>
                        }
                        @if (locale == 'es-ES') {
                          <span class="title"
                            >{{pod?.esTitle ?
                          pod?.esTitle : pod?.title }}</span>
                        }
                        @if (locale == 'en-US') {
                          <span class="title"
                            >{{pod?.enTitle ?
                          pod?.enTitle : pod?.title }}</span>
                        }
                      </a>
                    }
                    @if (pod?.podType === 'urlIntegration' && pod?.iframeCustomLink) {
                      <a (click)="onClickPod(pod.id, $event)"
                        [href]="getPodUrl(pod)">
                        <!-- <span class="title">{{pod.title}}</span> -->
                        @if (locale == 'pt-BR') {
                          <span class="title"
                          >{{pod?.title}}</span>
                        }
                        @if (locale == 'pt-PT') {
                          <span class="title"
                            >{{pod?.ptTitle ?
                          pod?.ptTitle : pod?.title }}</span>
                        }
                        @if (locale == 'es-ES') {
                          <span class="title"
                            >{{pod?.esTitle ?
                          pod?.esTitle : pod?.title }}</span>
                        }
                        @if (locale == 'en-US') {
                          <span class="title"
                            >{{pod?.enTitle ?
                          pod?.enTitle : pod?.title }}</span>
                        }
                      </a>
                    }
                    <i class="icon-thumbnail icon-menu-items-category pointer" (click)="onClickPod(pod.id, $event)">
                      @if (pod.podType === 'customLink' || pod.podType === 'urlIntegration' || pod.podType === 'wikiPage' || pod.podType === 'internalLink' || pod.podType === 'blogPost') {
                        <img [src]="'https://publicfiles.mybeehome.com/icons/custom-pods/'+pod.icon" width="24px" height="24px" [alt]="pod.title">
                      }
                      @if (pod.podType !== 'customLink' && pod.podType !== 'urlIntegration' && pod.podType !== 'wikiPage' && pod.podType !== 'internalLink' && pod.podType !== 'blogPost') {
                        <img [src]="'https://publicfiles.mybeehome.com/icons/default-pods/'+pod.icon+'.svg'" width="24px" height="24px" [alt]="pod.title">
                      }
                      @if (pod.unread > 0) {
                        <span [matTooltip]="getUnreadTooltip(pod)" class="bubble"
                          matTooltipPosition="above">
                          {{ pod.unread }}
                        </span>
                      }
                    </i>
                  </li>
                }
              </ul>
            </accordion-group>
          }
        </accordion>
      </ng-container>
    </div>
    <div class="clearfix"></div>
  </div>
</div>

@if (showDealerCodeModal) {
  <div class="dealer-code-modal-overlay">
    <div class="dealer-code-modal">
      <div class="modal-header">
        <h4 class="modal-title">{{'Selecione o código' | translate}}</h4>
      </div>
      <div class="modal-body">
        @if (loadingDealerCodes) {
          <div class="text-center mr-3">
            <span class="spinner-border spinner-border-sm text-primary" role="status"></span>
          </div>

        } @else if (dealerCodes.length === 0) {
          <div class="text-center p-20">
            <span>{{'Nenhum código encontrado' | translate}}</span>
          </div>
        } @else {
          <div class="dealer-code-list">
            @for (dealer of dealerCodes; track dealer.id) {
              <div class="dealer-code-item"
                   [class.selected]="selectedDealerCode === dealer.code"
                   (click)="selectDealerCode(dealer.code)">
                <div class="radio-indicator">
                  @if (selectedDealerCode === dealer.code) {
                    <div class="radio-inner"></div>
                  }
                </div>
                <div class="dealer-info">
                  <span class="dealer-code">{{dealer.code}}</span>
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div class="modal-footer">
        <button class="btn btn-default" (click)="cancelDealerCode()">{{'Cancelar' | translate}}</button>
        <button class="btn btn-primary" [disabled]="!selectedDealerCode || loadingDealerCodes" (click)="confirmDealerCode()">{{'Confirmar' | translate}}</button>
      </div>
    </div>
  </div>
}

